export default class {
    constructor(Configurator) {

    }

    get container()    { return document.querySelector('.mixer-design-bottom') }

    showExtraInfo(show) {
        this.container.classList.toggle('is-ready', show);
    }
}

